import React from "react";
import { RCCBadge, RCCIcon } from "react-common-components";
import { Body, DivContent } from "src/components/Card/styles";
import { useTranslation } from "src/context/Translations/context";
import { IDragCard } from "./interface";
import Container from "./styles";

const DragCard: React.FC<IDragCard> = ({
	dashboardTemplate
}) => {
	const { translate } = useTranslation();
  
	if(dashboardTemplate.dragEditingCard)
		return (
			<Container>
				<Body>
					<RCCIcon
						name="arrows"
						size={80}
						color="var(--input-font-color)"
						style={{ opacity: "0.25" }}
					/>
					<DivContent style={{ marginLeft: "0.75rem" }}>
						<strong>{dashboardTemplate.line ? translate("Linha") : "Card"}</strong>
						{dashboardTemplate.line ? translate("Linha em edição") : translate("Card em edição")}...
						<RCCBadge color="grey">{translate("Arrastando")}</RCCBadge>
					</DivContent>
				</Body>
			</Container>
		);

	return <Container>
		<Body>
			<img
				src={dashboardTemplate.src}
				alt={dashboardTemplate.description}
				style={{ width: "100px" }}
			/>
			<DivContent style={{ marginLeft: "0.75rem" }}>
				<strong>{translate(dashboardTemplate.title)}</strong>
				{translate(dashboardTemplate.description)}
			</DivContent>
		</Body>
	</Container>;
};

export default DragCard;
